import * as IntlPolyfill from 'intl';
import * as areIntlLocalesSupported from 'intl-locales-supported';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/id';

import { SUPPORTED_LOCALES } from 'constants/locale';

if (global.Intl) {
  // Determine if the built-in `Intl` has the locale data we need.
  if (!areIntlLocalesSupported(SUPPORTED_LOCALES)) {
    // `Intl` exists, but it doesn't have the data we need, so load the
    // polyfill and replace the constructors with need with the polyfill's.
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
  }
} else {
  // No `Intl`, so use and load the polyfill.
  global.Intl = IntlPolyfill;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/locale/tool/polyfill.ts